import React from 'react'
import { PUBLIC_URL } from './environment'
import { BrowserRouter as Router, useRouteMatch } from 'react-router-dom'
import { logDebug } from './debug/debugLogging'

function LegacyListRedirectChild() {
  const legacyRouteMatch = useRouteMatch<{ listId: string }>('/list/:listId')

  React.useEffect(() => {
    if (legacyRouteMatch) {
      const listId = legacyRouteMatch.params.listId
      if (listId) {
        logDebug('Router', 'redirecting from legacy list', legacyRouteMatch.url)

        window.location.href = `${PUBLIC_URL}${legacyRouteMatch.url}`
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <React.Fragment/>
  )
}

/**
 * Creates a client-size redirect for shared list urls from fromBasePath if the current PUBLIC_URL matches toBasePathMatch
 * e.g. redirect /build-iconic/list/abc123 -> /clipsal-switch-socket-builder/list/abc123
 * @param props
 * @constructor
 */
export function LegacyListUrlRedirecter(props: {
  toBasePathMatch: string
  fromBasePath: string
}) {
  const {
    toBasePathMatch,
    fromBasePath,
  } = props

  return (
    <>
      {
        PUBLIC_URL?.startsWith(toBasePathMatch) && (
          <Router basename={fromBasePath}>
            <LegacyListRedirectChild />
          </Router>
        )
      }
    </>
  )
}
